export default __webpack_public_path__ + "static/media/04-large.8fdb9d4a.jpg";